module.exports = __webpack_public_path__ + "img/大背景.7465393d.png";